export default __webpack_public_path__ + "static/Row 1.3_Starlearners-3d1a5c7130da118f4158a16b7ea9339c.jpg";